import React from "react";
import i18n from "../../../../i18n/i18n";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import {withRouter} from "react-router";
import {PortModel} from "../../../models/ports";
import {PortService} from "../../../services/portService";
import PortForm from "../portForm/portForm";


class ModifyPort extends ModifyItem<PortModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await PortService.getPort(this.props.match.params?.id));
    }

    render() {
        return (
            <div className="modify-port modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.ports.actions.modifyPort.header"))}
                    {this.renderContent(<PortForm isUpdate={true} portData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyPort);

